import type {
  GetSchemaViewerFieldExpressionContextProps,
  GetSchemaViewerFieldPrintExpressionsProps,
} from "./schema-viewer-field-expression-label.type";
import type { VariableNode } from "@stelar/expression-engine";

import {
  getVariablesNodeFromAST,
  printExpression,
} from "@stelar/expression-engine";

export const getSchemaViewerFieldExpressionContext = ({
  expressionSchema,
  form,
  schemaFormLabels,
}: GetSchemaViewerFieldExpressionContextProps) => {
  let variables: VariableNode[] = [];

  try {
    variables = getVariablesNodeFromAST(expressionSchema.expression);
  } catch {
    /* nothing */
  }

  return variables.map(({ variable, model }) => {
    return {
      variable,
      model,
      value: form.getFieldValue(model),
      label: schemaFormLabels[model] || model,
    };
  });
};

export const getSchemaViewerFieldPrintExpressions = ({
  expressionSchema,
  form,
  schemaFormLabels,
  result,
}: GetSchemaViewerFieldPrintExpressionsProps) => {
  let expressionWithLabels: string = "";
  let expressionWithValues: string | undefined = undefined;

  const context = getSchemaViewerFieldExpressionContext({
    expressionSchema,
    form,
    schemaFormLabels,
  });

  try {
    expressionWithLabels = printExpression(
      expressionSchema.expression,
      context,
      { printType: "label" }
    );
    const withValues = printExpression(expressionSchema.expression, context, {
      printType: "value",
    });
    expressionWithValues = result
      ? `${withValues} = ${result} ${expressionSchema.unit ?? ""}`.trim()
      : undefined;
  } catch {
    /* nothing */
  }

  return {
    expressionWithLabels,
    expressionWithValues,
  };
};
